export const IconAutorenew = (props: IconClip) => {
	return (
		<svg version="1.1" width={props.width ?? "24px"} height={props.height ?? "24px"} xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
			<path
				fill={props.color ?? "#000000"}
				d="M204-318q-22-38-33-78t-11-84q0-134 93-228t227-94h7l-64-64 56-56 160 160-160 160-56-56 63-63h-6q-100 0-170 70.5T240-480q0 26 6 51t18 49l-60 62ZM480-40 320-200l160-160 56 56-63 64h6q100 0 170-70.5T719-480q0-26-6-51t-18-49l60-62q22 38 33 78t11 84q0 134-93 228t-227 94h-7l64 64-56 56Z"
			/>
		</svg>
	);
};
